const FEEDBACK_TYPES = {
    NEW: "first_alert_subscription",
    SUCCESS: "subscription_successful",
    EXISTING: "already_subscribed",
    REMOVED: "subscription_removed"
}

const DATA_TYPES = {
    SECTION: 2,
    CONCEPT: 1
}
export { FEEDBACK_TYPES }
export { DATA_TYPES }